export default __webpack_public_path__ + "static/194-33e52f450e49d580327533537a029ff5.jpg";